<template>
  <div class="container">
    <div class="handle-wrapper">
      <Input
        v-model="searchText"
        search
        placeholder="搜索产品..."
        @on-change="searchMaterial"
        style="width: 250px; margin-right: auto"
      >
        <Button slot="append" icon="ios-search" @click="searchMaterial"></Button>
      </Input>
      <span>共{{ totalRows }}条</span>
      <Page
        :total="totalRows"
        :page-size="50"
        @on-change="loadMaterial"
        show-total
        simple
        style="margin-right: 24px"
      />
      <Button
        v-if="
          user.superAdmin ||
          arrayIntersection(
            ['allFactoryLeader', 'salesAssist'],
            user.simpleRole
          ).length > 0
        "
        type="primary"
        @click="openEditMaterialDrawer()"
      >新增产品</Button>
    </div>
    <div class="table-wrapper" ref="tableWrapper">
      <Table
        border
        :loading="tableLoading"
        :columns="columns"
        :data="tableData"
        :height="tableHeight"
      ></Table>
    </div>
    <EditMaterialDrawer ref="EditMaterialDrawer" v-on:editSuccess="loadMaterial" />
  </div>
</template>

<script>
import EditMaterialDrawer from "../RawMaterialPage/EditMaterialDrawer";
import { mapState, mapActions, mapGetters } from "vuex";
import { arrayIntersection } from "@/utils";
import _ from "lodash";

export default {
  name: "Product",
  components: { EditMaterialDrawer },
  props: {},
  data() {
    return {
      page: 0,
      searchText: "",
      tableLoading: false,
      filterQuery: { limit: 50 },
      tableHeight: 300,
      columns: [
        {
          title: "行",
          key: "row",
          width: 60,
          align: "center",
          render: (h, params) =>
            h(
              "span",
              { style: { color: "darkgray" } },
              this.page * 15 + params.index + 1
            )
        },
        {
          title: "产品型号",
          key: "name",
          render: (h, params) => {
            if (
              this.user.superAdmin ||
              arrayIntersection(
                ["allFactoryLeader", "salesAssist"],
                this.user.simpleRole
              ).length > 0
            ) {
              return h("div", [
                h(
                  "h4",
                  {
                    props: {
                      type: "text",
                      size: "small"
                    },
                    style: {
                      color: "#42b983",
                      cursor: "pointer"
                    },
                    on: {
                      click: () => {
                        this.$refs.EditMaterialDrawer.openDrawer(
                          "product",
                          params.row
                        );
                      }
                    }
                  },
                  params.row.model
                )
              ]);
            } else {
              return h("h4", params.row.model);
            }
          }
        },
        {
          title: "产品名字",
          key: "name"
        }
      ]
    };
  },
  computed: {
    ...mapState({
      tableData: state => state.material.materials,
      totalRows: state => state.material.totalCounts,
      user: state => state.auth.currentUser
    })
  },
  methods: {
    arrayIntersection(array, targetArray) {
      return arrayIntersection(array, targetArray);
    },
    ...mapActions({
      getMaterials: "material/getMaterialsAction"
    }),
    openEditMaterialDrawer() {
      this.$refs.EditMaterialDrawer.openDrawer("product");
    },
    async loadMaterial(page) {
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        type: "product",
        skip: this.page * 50
      };
      if (this.searchText) {
        this.filterQuery.name = this.searchText;
      } else {
        delete this.filterQuery.name;
      }
      try {
        this.tableLoading = true;
        await this.getMaterials(this.filterQuery);
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
        this.tableLoading = false;
      }
    },
    searchMaterial: _.debounce(function() {
      this.page = 0;
      this.loadMaterial();
    }, 1000)
  },
  created() {
    this.loadMaterial();
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  }
};
</script>

<style scoped lang="stylus">
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content flex-end

.table-wrapper
  width 100%
  height calc(100% - 48px)
</style>
